import _ from 'lodash';
import { createSelector } from 'reselect';

import { dropDownDocumentFieldTypes } from 'constants/documentFieldTypes';
import {
  createDocumentFieldTypesPath,
  getOptionFieldTypeFromOption,
} from 'utils/documentFieldTypes';

import { getSystem } from './system.selectors';

export const getDocumentFieldTypes = createSelector(
  getSystem,
  ({ documentFieldTypes }) => documentFieldTypes,
);

const getDocumentFieldTypesValues = createSelector(getDocumentFieldTypes, fieldTypes =>
  _.sortBy(Object.values(fieldTypes), ({ name }) => name.toLowerCase()),
);

export const getDocumentFieldTypesValuesWithOptions = createSelector(
  getDocumentFieldTypesValues,
  fieldTypes => {
    const extendedDocumentFieldTypes = fieldTypes.reduce((acc, fieldType) => {
      if (dropDownDocumentFieldTypes.includes(fieldType.typeDefinition.type)) {
        fieldType.options.forEach(option => {
          const optionFieldType = getOptionFieldTypeFromOption({
            name: option,
            parentId: fieldType.id,
          });

          acc.push(optionFieldType);
        });
      }

      acc.push(fieldType);

      return acc;
    }, []);

    return extendedDocumentFieldTypes;
  },
);

export const selectDocumentFieldTypesValuesWithParentName = createSelector(
  [getDocumentFieldTypesValues, getDocumentFieldTypes],
  (partialFieldTypes, documentFieldTypes) => {
    const fieldTypesWithParentName = partialFieldTypes.reduce((acc, fieldType) => {
      if (fieldType.parentId && !documentFieldTypes[fieldType.parentId]) {
        return acc;
      }

      acc.push({
        ...fieldType,
        parentName: fieldType.parentId
          ? createDocumentFieldTypesPath(documentFieldTypes, documentFieldTypes[fieldType.parentId])
          : 'root',
      });

      return acc;
    }, []);

    return _.sortBy(fieldTypesWithParentName, 'parentName');
  },
);

const incorrectTypes = ['container', 'complex'];
export const selectDocumentFieldTypesOptions = createSelector(
  selectDocumentFieldTypesValuesWithParentName,
  documentFieldTypes =>
    documentFieldTypes.filter(
      ({ typeDefinition }) => !incorrectTypes.includes(typeDefinition.type.toLowerCase()),
    ),
);
